import React from "react";

const GroupALeaderboard = (props) => {
  return (
    <>
      <table className="main-table1 table innertable">
        <thead>
          <tr>
            <th>Mananger</th>
            <th title="Played">P</th>
            <th title="Wins">W</th>
            <th title="Losses">L</th>
            <th title="Ties">T</th>
            <th title="Win %">W%</th>
            <th title="Points For">PF</th>
            <th title="Points Against">PA</th>
            <th title="Points Difference">PD</th>
            <th title="Points">PTS</th>
          </tr>
        </thead>
        <tbody>
          {props.groupOneLeaderboard &&
            props.groupOneLeaderboard.map((item, key) => (
              <tr key={key}>
                <td>{item?.full_name}</td>
                <td>{item?.played}</td>
                <td>{item?.wins}</td>
                <td>{item?.losses}</td>
                <td>{item?.ties}</td>
                <td>{item?.win_percentage}</td>
                <td>{item?.points_for}</td>
                <td>{item?.points_against}</td>
                <td>{item?.point_difference}</td>
                <td>{item?.points}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default GroupALeaderboard;
